module.exports = __webpack_public_path__ + "static/media/t-120.3262a34e.jpg";